import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Dingley – Recycled Water Scheme Transfer Main </h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        The Transfer Main of the Dingley Recycled Water Scheme is around 12km of the total 42km scheme.
        </p>
        <p>
        Our industry partner Abergeldie, KBR, BMD Joint Venture (ABK) started construction on the Transfer Main from Pillars Road in September 2025. We expect construction to take approximately 12-18 months.
        </p>
        <p>
        To get the job done as quickly as possible, we may have multiple crews working at the same time. We’ll let residents and businesses know before we start works in each area.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/residential/upgrades-and-projects/projects/dingley-recycled-water-scheme/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Dingley - Recycled Water Scheme Trunk Main (Stage 1)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800330129">1800 330 129</a> |{' '}
          <a
            href="mailto:dingley@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: DINGLEY@SEW.COM.AU - Dingley - Recycled Water Scheme Trunk Main (Stage 1)',
              });
            }}
          >
            dingley@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
